import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import PhoneCall from './icon-phone-call.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PhoneCall {...validProps} />;
}
SvgComponent.iconName = 'phoneCall';

/**
 * @deprecated This is a legacy icon
 */
export const PhoneCallIcon = svgIconWrapper(SvgComponent);
